import React, { useEffect } from 'react';
import { Routes, Route, useSearchParams } from 'react-router-dom';
import useLocalStorage from '../../shared/hooks/useLocalStorage';
import { autoMergeContent } from '../../shared/engine/contentMerger';
import { getStarterDeck, CONTENT_VERSION } from './data/starterDeck';
import Dashboard from './components/Dashboard';
import CardReview from './components/CardReview';
import CardEditor from './components/CardEditor';
import CardBrowser from './components/CardBrowser';
import DeckManager from './components/DeckManager';

/**
 * Flashcard Engine root.
 * Manages card state and seeds starter deck on first load.
 */
export default function FlashcardApp() {
  const [cards, setCards] = useLocalStorage('flashcards', 'all', []);
  const [sessionHistory, setSessionHistory] = useLocalStorage('flashcards', 'session-history', []);

  // Auto-merge: seeds on first load AND adds new cards from code updates
  useEffect(() => {
    autoMergeContent({
      namespace: 'flashcards',
      key: 'all',
      seedData: getStarterDeck(),
      seedVersion: CONTENT_VERSION,
      currentData: cards,
      setData: setCards,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Routes>
      <Route path="/" element={<Dashboard cards={cards} sessionHistory={sessionHistory} />} />
      <Route path="/review" element={<ReviewRoute cards={cards} setCards={setCards} />} />
      <Route path="/edit/:id" element={<CardEditor cards={cards} setCards={setCards} />} />
      <Route path="/edit" element={<CardEditor cards={cards} setCards={setCards} />} />
      <Route path="/browse" element={<CardBrowser cards={cards} />} />
      <Route path="/deck" element={<DeckManager cards={cards} setCards={setCards} />} />
    </Routes>
  );
}

/**
 * Review route wrapper — reads mode from query params.
 */
function ReviewRoute({ cards, setCards }) {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') || 'review';
  const domain = searchParams.get('domain') || null;

  return (
    <CardReview
      cards={cards}
      setCards={setCards}
      mode={mode}
      cramDomain={domain}
    />
  );
}
